const option = [
    { id: '10', name: 'กรุงเทพมหานคร' },
    { id: '11', name: 'สมุทรปราการ' },
    { id: '12', name: 'นนทบุรี' },
    { id: '13', name: 'ปทุมธานี' },
    { id: '14', name: 'พระนครศรีอยุธยา' },
    { id: '15', name: 'อ่างทอง' },
    { id: '16', name: 'ลพบุรี' },
    { id: '17', name: 'สิงห์บุรี' },
    { id: '18', name: 'ชัยนาท' },
    { id: '19', name: 'สระบุรี' },
    { id: '20', name: 'ชลบุรี' },
    { id: '21', name: 'ระยอง' },
    { id: '22', name: 'จันทบุรี' },
    { id: '23', name: 'ตราด' },
    { id: '24', name: 'ฉะเชิงเทรา' },
    { id: '25', name: 'ปราจีนบุรี' },
    { id: '26', name: 'นครนายก' },
    { id: '27', name: 'สระแก้ว' },
    { id: '30', name: 'นครราชสีมา' },
    { id: '31', name: 'บุรีรัมย์' },
    { id: '32', name: 'สุรินทร์' },
    { id: '33', name: 'ศรีสะเกษ' },
    { id: '34', name: 'อุบลราชธานี' },
    { id: '35', name: 'ยโสธร' },
    { id: '36', name: 'ชัยภูมิ' },
    { id: '37', name: 'อำนาจเจริญ' },
    { id: '39', name: 'หนองบัวลำภู' },
    { id: '40', name: 'ขอนแก่น' },
    { id: '41', name: 'อุดรธานี' },
    { id: '42', name: 'เลย' },
    { id: '43', name: 'หนองคาย' },
    { id: '44', name: 'มหาสารคาม' },
    { id: '45', name: 'ร้อยเอ็ด' },
    { id: '46', name: 'กาฬสินธุ์' },
    { id: '47', name: 'สกลนคร' },
    { id: '48', name: 'นครพนม' },
    { id: '49', name: 'มุกดาหาร' },
    { id: '50', name: 'เชียงใหม่' },
    { id: '51', name: 'ลำพูน' },
    { id: '52', name: 'ลำปาง' },
    { id: '53', name: 'อุตรดิตถ์' },
    { id: '54', name: 'แพร่' },
    { id: '55', name: 'น่าน' },
    { id: '56', name: 'พะเยา' },
    { id: '57', name: 'เชียงราย' },
    { id: '58', name: 'แม่ฮ่องสอน' },
    { id: '60', name: 'นครสวรรค์' },
    { id: '61', name: 'อุทัยธานี' },
    { id: '62', name: 'กำแพงเพชร' },
    { id: '63', name: 'ตาก' },
    { id: '64', name: 'สุโขทัย' },
    { id: '65', name: 'พิษณุโลก' },
    { id: '66', name: 'พิจิตร' },
    { id: '67', name: 'เพชรบูรณ์' },
    { id: '70', name: 'ราชบุรี' },
    { id: '71', name: 'กาญจนบุรี' },
    { id: '72', name: 'สุพรรณบุรี' },
    { id: '73', name: 'นครปฐม' },
    { id: '74', name: 'สมุทรสาคร' },
    { id: '75', name: 'สมุทรสงคราม' },
    { id: '76', name: 'เพชรบุรี' },
    { id: '77', name: 'ประจวบคีรีขันธ์' },
    { id: '80', name: 'นครศรีธรรมราช' },
    { id: '81', name: 'กระบี่' },
    { id: '82', name: 'พังงา' },
    { id: '83', name: 'ภูเก็ต' },
    { id: '84', name: 'สุราษฎร์ธานี' },
    { id: '85', name: 'ระนอง' },
    { id: '86', name: 'ชุมพร' },
    { id: '90', name: 'สงขลา' },
    { id: '91', name: 'สตูล' },
    { id: '92', name: 'ตรัง' },
    { id: '93', name: 'พัทลุง' },
    { id: '94', name: 'ปัตตานี' },
    { id: '95', name: 'ยะลา' },
    { id: '96', name: 'นราธิวาส' },
    { id: '97', name: 'บึงกาฬ' }
];

const method = {
    getValueByKey(id) {
        return option.find(x => x.id === id).name;
    }
}

export default {
    option: option,
    service: method
};